import { render, staticRenderFns } from "./ScrollToResBtn.vue?vue&type=template&id=321d1efe"
import script from "./ScrollToResBtn.vue?vue&type=script&lang=js"
export * from "./ScrollToResBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports